import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import UploadQuestionnaireRequest from "../../../Communication/ApiClasses/UploadQuestionnaireRequest";

// worker
function* sumitQuestionnaire(action) {
  yield put(doLoadingStart(`${actionTypes.UPLOAD_QUESTIONNAIRE}_SAGA`));
  const uploadQuestionnaireRequest = new UploadQuestionnaireRequest(
    action.data
  );
  try {
    const result = yield call(uploadQuestionnaireRequest.getData);
    yield put({
      type: `${actionTypes.UPLOAD_QUESTIONNAIRE}_SUCCESS`,
      error: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: `${actionTypes.UPLOAD_QUESTIONNAIRE}_ERROR`,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(`${actionTypes.UPLOAD_QUESTIONNAIRE}_SAGA`));
  }
}

// watcher
function* handleSaga() {
  yield takeLatest(actionTypes.UPLOAD_QUESTIONNAIRE, sumitQuestionnaire);
}

export default handleSaga;
